
import { faqCategories } from '../../../mocks/faqData';
import useScrollAnimation from '../../../hooks/useScrollAnimation';

interface FaqCategoriesProps {
  activeCategory: string;
  onCategoryChange: (id: string) => void;
  counts: Record<string, number>;
}

const FaqCategories = ({ activeCategory, onCategoryChange, counts }: FaqCategoriesProps) => {
  const { ref: sectionRef, isVisible } = useScrollAnimation({ threshold: 0.15 });

  return (
    <section className="py-16 px-6 lg:px-12 bg-white border-b border-gray-100">
      <div ref={sectionRef} className="max-w-7xl mx-auto">
        <div
          className={`text-center mb-10 transition-all duration-700 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          <h2 className="text-3xl font-bold text-gray-900 mb-3">
            Explora por Categoría
          </h2>
          <p className="text-gray-500 text-base">
            Selecciona una categoría para encontrar respuestas rápidas sobre desguace en Gavá
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-8 gap-3">
          <button
            onClick={() => onCategoryChange('todas')}
            className={`flex flex-col items-center p-4 rounded-xl transition-all cursor-pointer duration-500 ${
              isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
            } ${
              activeCategory === 'todas'
                ? 'bg-emerald-600 text-white shadow-lg shadow-emerald-200'
                : 'bg-gray-50 text-gray-700 hover:bg-emerald-50 hover:text-emerald-700'
            }`}
            style={{ transitionDelay: `${200}ms` }}
          >
            <div className={`w-10 h-10 flex items-center justify-center rounded-full mb-2 ${
              activeCategory === 'todas' ? 'bg-white/20' : 'bg-emerald-100'
            }`}>
              <i className={`ri-apps-line text-lg ${activeCategory === 'todas' ? 'text-white' : 'text-emerald-600'}`}></i>
            </div>
            <span className="text-xs font-semibold whitespace-nowrap">Todas</span>
            <span className={`text-xs mt-1 ${activeCategory === 'todas' ? 'text-white/80' : 'text-gray-400'}`}>
              {Object.values(counts).reduce((a, b) => a + b, 0)}
            </span>
          </button>

          {faqCategories.map((cat, index) => (
            <button
              key={cat.id}
              onClick={() => onCategoryChange(cat.id)}
              className={`flex flex-col items-center p-4 rounded-xl transition-all cursor-pointer duration-500 ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
              } ${
                activeCategory === cat.id
                  ? 'bg-emerald-600 text-white shadow-lg shadow-emerald-200'
                  : 'bg-gray-50 text-gray-700 hover:bg-emerald-50 hover:text-emerald-700'
              }`}
              style={{ transitionDelay: `${250 + index * 60}ms` }}
            >
              <div className={`w-10 h-10 flex items-center justify-center rounded-full mb-2 ${
                activeCategory === cat.id ? 'bg-white/20' : 'bg-emerald-100'
              }`}>
                <i className={`${cat.icon} text-lg ${activeCategory === cat.id ? 'text-white' : 'text-emerald-600'}`}></i>
              </div>
              <span className="text-xs font-semibold whitespace-nowrap">{cat.label}</span>
              <span className={`text-xs mt-1 ${activeCategory === cat.id ? 'text-white/80' : 'text-gray-400'}`}>
                {counts[cat.id] || 0}
              </span>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FaqCategories;
